import React from 'react';
import { mockPipeline } from '../../data/mockData';
import SafeIcon from '../../common/SafeIcon';

export default function Pipeline() {
  const stages = [
    { id: 'leads', name: 'Leads', color: 'border-l-blue-500' },
    { id: 'pitching', name: 'Pitching', color: 'border-l-purple-500' },
    { id: 'negotiating', name: 'Negotiating', color: 'border-l-yellow-500' },
    { id: 'won', name: 'Closed Won', color: 'border-l-invoice-green' }
  ];

  return (
    <div className="h-full flex flex-col animate-in fade-in duration-500">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-light text-cream">Client Pipeline</h1>
          <p className="text-sm text-cream-muted mt-1">Manage incoming leads and active negotiations.</p>
        </div>
        <button className="bg-invoice-green hover:bg-emerald-400 text-[#111] px-4 py-2 rounded-lg font-medium text-sm transition-colors flex items-center gap-2">
          <SafeIcon name="Plus" className="w-4 h-4" />
          Add Lead
        </button>
      </div>

      <div className="flex-1 flex gap-6 overflow-x-auto custom-scrollbar pb-4">
        {stages.map(stage => (
          <div key={stage.id} className="min-w-[300px] flex-1 bg-charcoal-panel/50 rounded-xl border border-[#333] flex flex-col">
            <div className={`p-4 border-b border-[#333] ${stage.color} border-l-4 rounded-tl-xl`}>
              <div className="flex justify-between items-center">
                <h3 className="font-medium text-cream">{stage.name}</h3>
                <span className="text-xs bg-charcoal-light px-2 py-1 rounded-full text-cream-muted">
                  {mockPipeline[stage.id].length}
                </span>
              </div>
            </div>
            
            <div className="p-3 flex-1 overflow-y-auto custom-scrollbar space-y-3">
              {mockPipeline[stage.id].map(item => (
                <div key={item.id} className="glass-panel p-4 rounded-lg cursor-grab hover:border-[#555] transition-colors">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="font-medium text-cream">{item.client}</h4>
                    <span className="text-sm font-mono text-invoice-green">{item.value}</span>
                  </div>
                  <div className="flex items-center gap-2 text-xs text-cream-muted">
                    <SafeIcon name="Tag" className="w-3 h-3" />
                    {item.type}
                  </div>
                </div>
              ))}
              
              <button className="w-full py-3 border border-dashed border-[#444] rounded-lg text-cream-muted hover:text-cream hover:border-[#666] transition-colors text-sm flex items-center justify-center gap-2">
                <SafeIcon name="Plus" className="w-4 h-4" />
                Add Card
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}